import { render, staticRenderFns } from "./UpdateLog.vue?vue&type=template&id=225a7b36&scoped=true&"
import script from "./UpdateLog.vue?vue&type=script&lang=js&"
export * from "./UpdateLog.vue?vue&type=script&lang=js&"
import style0 from "./UpdateLog.vue?vue&type=style&index=0&id=225a7b36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225a7b36",
  null
  
)

export default component.exports